export default __webpack_public_path__ + "static/media/checkbox-default-big.b9338529.svg";